import axios from 'axios';
import { setUser } from '../actions';
import store from '../store';

const root = process.env.REACT_APP_API_ROOT || '';


const api = axios.create({
  withCredentials: process.env.NODE_ENV === 'development',
})


// Add a request interceptor
api.interceptors.request.use(function (config) {
  const state = store.getState();

  // Add auth header
  if (state.user && state.user.token) {
    config.headers.Authorization = `Bearer ${state.user.token}`
  } 

  return config;
});


// Add a response interceptor
api.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {

  const originalRequest = error.config;

  if (!error.response) {
    return Promise.reject(error);;
  }

  // If we already tried refresh token and we're still not logged in, redirect to log in
  if (error.response.status === 401 && originalRequest.url === `${root}/api/user/refreshToken`) {
    window.location = `/login?redirect=${window.location.pathname}`;
    return Promise.reject(error);
  }

  // If we get unauthorized error, try to get a refresh token
  if (error.response.status === 401 && !originalRequest._retry) {
  
    originalRequest._retry = true;
    return axios.post(`${root}/api/user/refreshToken`, {})
        .then(res => {
          // store token/user data
          store.dispatch(setUser(res.data))

          // set new header
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token;

          // retry original request request
          return axios(originalRequest);
        })
  }
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});


export default {

  // mockRoute: () => new Promise(function(resolve, reject) {
  //                   setTimeout(function() {
  //                     resolve({
  //                       data: { }
  //                     })
  //                   }, 1000) // throttle to simulate loading data
  // }),

  // User routes
  createUser: user => api.post(`${root}/api/users`, user),

  deleteUser: userId => api.delete(`${root}/api/users/${userId}`),

  getUser: userId => api.get(`${root}/api/users/${userId}`),

  getUsers: () => api.get(`${root}/api/users`),

  updateUser: user => api.put(`${root}/api/users/${user.id}`, user),

  // Session routes
  login: data => api.post(`${root}/api/user/login`, data),
  
  logout: () => api.post(`${root}/api/user/logout`, {}),
  
  refreshToken: () => api.post(`${root}/api/user/refreshToken`, {}),

  // Interactive routes
  createInteractive: data => api.post(`${root}/api/interactives`, data),

  deleteInteractive: (id,lockUuid) => api.delete(`${root}/api/interactives/${id}${lockUuid ? `?lockuuid=${lockUuid}` : '' }`),

  getExport: id => api.get(`${root}/api/interactives/${id}/export`),

  getInteractive: id => api.get(`${root}/api/interactives/${id}`),

  getInteractives: () => api.get(`${root}/api/interactives`),

  importInteractive: (formData) => api.post(`${root}/api/interactives/import`, formData, {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }),

  updateInteractive: (id, data) => api.put(`${root}/api/interactives/${id}`, data),

  // Images
  deleteImage: (uuid, filename, lockUuid) => api.delete(`${root}/api/images/${uuid}/${filename}${lockUuid ? `?lockuuid=${lockUuid}` : '' }`),

  uploadImage: formData => api.post(`${root}/api/images`, formData, {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }),

  // misc
  lockIntv: (uuid,lastEdited) => api.post(`${root}/api/interactivelocks`, {
    interactiveUuid: uuid, 
    updatedAt: lastEdited
  }),
  unlockIntv: (lockUuid) => api.delete(`${root}/api/interactivelocks/${lockUuid}`),

}